import React,{useState} from 'react';
import { GoogleMap,useLoadScript,Marker,InfoWindow} from '@react-google-maps/api';
import "../reclamacoes.css";

const mapContainerStyle={
  width:"100%",
  height:`${Math.abs(`${localStorage.getItem('cliheig')}`-`${localStorage.getItem('clientight')}`)}px`
};
const center={
  lat:-25.948160546759134, 
  lng:32.58577582313654
};
function Reclamacoes() {
  const [selecionado,setSelecionado]=useState(null);

  const {isLoaded,loadError}=useLoadScript({
    googleMapsApiKey:"AIzaSyDPULpH4t1OW6WExQUqmD3K1EuOCBKq6Ec",
  }); 
  if(loadError) return "errro lendo"
  if(!isLoaded) return "Loading Map"
return (
  <div className="mapa">
    <GoogleMap mapContainerStyle={mapContainerStyle} zoom={8}
    center={center}>
         <Marker position={{  lat:parseFloat('-25.9149524'), 
              lng:parseFloat('32.6390378,15')}}
              icon={{url:'/meter.png'}}
              onClick={()=>{
                setSelecionado({});
             
              }}/>
                 {selecionado ? (<InfoWindow position={{lat:parseFloat('-25.9149524'), 
                lng:parseFloat('32.6390378,15')}} onCloseClick={()=>{setSelecionado(null);  }}>
                <div>
                  <h4>Anisio Maximiano Djedje</h4>
                  <p>BI:232323232323A</p>
                  <p>morada:Magoanine B,Casa 79,Quarteirao 25</p>
                  <p>email:anisio.djedje@uem.ac.mz</p>
                  <p>telemovel:+258848911419</p>
                  <p>Data da Reclamacao:2022-03-08T07:32:43Z</p>
                  <p>Descricao:bateria Fraca</p>
                </div>
              </InfoWindow>
              ) : null}
              
    </GoogleMap>
  </div>
);

}

export default Reclamacoes;
